<template>
    <div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
        <div class="form-group mb-2">
            <label class="d-block font-weight-bold">
                {{ label }}
                <span v-if="required" class="text-danger">*</span>
            </label>

            <div class="input-group mb-3">
                <v-select
                    class="col px-0"
                    :options="array"
                    :multiple="multiple"
                    :disabled="disabled || false"
                    :required="required"
                    label="value"
                    :reduce="item => item.id"
                    v-model="item"
                    :clearable="false"
                    @option:selected="$emit('selected', item)"
                    v-on:input="$emit('input', item), $emit('change')"
                    placeholder="Selecione uma opção"
                >
                    <template #search="{ attributes, events }">
                        <input
                            class="vs__search"
                            :required="required && !item"
                            v-bind="attributes"
                            v-on="events"
                        />
                    </template>
                    <template slot="no-options">
                        <em style="opacity: 0.5" v-if="array.length == 0">
                            Nenhum resultado encontrado.
                        </em>
                        <span v-else> Pesquise {{ label }}..</span>
                    </template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center" v-html="option.value"></div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div
                            class="selected d-center"
                            v-html="option.value"
                        ></div>
                    </template>
                </v-select>
                <!-- <div class="input-group-append">
					<button
						class="btn btn-outline-secondary px-2"
						type="button"
						@click="$emit('submit')"
					>
						<i :class="btnIcon"></i>
					</button>
				</div> -->
                <div class="input-group-append">
                    <button
                        class="btn"
                        :class="btnClass ? btnClass : 'btn-outline-secondary'"
                        type="button"
                        @click="$emit('submit')"
                    >
                        <i :class="btnIcon" v-if="btnIcon"></i>
                        <span v-else>{{ btnText }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        "value",
        "itens",
        "label",
        "grid",
        "required",
        "disabled",
        "mt",
        "urlSearch",
        "multiple",
        "btnIcon",
        "btnClass",
        "btnText"
    ],
    data() {
        return { item: { id: null, value: null }, array: [] };
    },
    beforeMount() {
        this.item = this.value;
        if (Array.isArray(this.itens)) {
            this.array = this.itens;
        }
    },
    watch: {
        value(n, o) {
            this.item = n;
        },
        itens(n, o) {
            this.array = n;
        }
    },
    methods: {
        onSearch() {}
    }
};
</script>
<style lang="css">
.vs__dropdown-menu {
    display: block;
    box-sizing: border-box;
    position: absolute;
    top: calc(100% - 1px);
    left: 0;
    z-index: 99 !important;
    padding: 5px 0;
    margin: 0;
    width: 100% !important;
    max-height: 350px;
    min-width: 160px;
    overflow-y: auto;
    box-shadow: 0px 3px 6px 0px rgb(0 0 0 / 15%);
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-top-style: none;
    border-radius: 0 0 4px 4px;
    text-align: left;
    list-style: none;
    background: #fff;
}
</style>
